var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "svg-safari-fix",
  viewBox: "0 0 16 16",
  fill: "inherit"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.9498 4.95C6.6498 5.4 5.9498 6.1 5.4998 8.4C5.0498 6.1 4.3498 5.4 2.0498 4.95C4.3498 4.5 5.0498 3.8 5.4998 1.5C5.9498 3.8 6.6498 4.5 8.9498 4.95Z",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9001 12.5016C9.3001 12.8016 8.8501 13.3016 8.5001 14.9016C8.2001 13.3016 7.7001 12.8516 6.1001 12.5016C7.7001 12.2016 8.1501 11.7016 8.5001 10.1016C8.8001 11.7016 9.3001 12.2016 10.9001 12.5016Z",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5001 7.50078C13.2001 7.75078 12.8001 8.15078 12.5501 9.45078C12.3001 8.15078 11.9001 7.75078 10.6001 7.50078C11.9001 7.25078 12.3001 6.85078 12.5501 5.55078C12.8001 6.85078 13.2001 7.25078 14.5001 7.50078Z",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSparks;